import { createSelector } from 'reselect';
const getState = (state) => state.error;
export const getError = createSelector(getState, error => {
    return error;
});
